import script from "./GitConfigModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GitConfigModal.vue?vue&type=script&setup=true&lang=ts"

import "./GitConfigModal.vue?vue&type=style&index=0&id=0e51762a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e51762a"]])

export default __exports__